import { Component, OnInit, ViewChild } from '@angular/core';
import {
  NgbModal,
  NgbModalRef,
  NgbDropdownConfig
} from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { ApiService } from '../api/api.service';
import { AuthService } from '../api/auth.service';
import { IPService } from '../api/ip.service';
import * as LoginActions from './login.actions';
import { UserService } from '../api/user.service';
import { AppSettings } from '../app.settings';
import { UserModel } from './login.model';
import {
  BillingInfo,
  BillingInfoActions
} from '../transaction-store/billing-info';
import {
  TributeInfo,
  TributeInfoActions
} from '../transaction-store/tribute-info';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  template: `
    <div class="container login">
      <div class="row">
        <div class="col-12">
          <div class="float-right">
            <button
              class="btn btn-primary"
              (click)="openLoginModal(content)"
              *ngIf="!loggedIn"
            >
              Login
            </button>
            <div ngbDropdown>
              <button
                type="button"
                id="loginMenu"
                *ngIf="loggedIn"
                class="btn btn-primary"
                ngbDropdownToggle
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ username }}
                <div class="dropdown-custom-icon"></div>
              </button>
              <ul
                class="dropdown-menu dropdown-menu-right"
                role="menu"
                ngbDropdownMenu
                aria-aria-labelledby="loginMenu"
              >
                <li
                  (click)="manageAccount(null)"
                  aria-label="Manage Account"
                  role="menuitem"
                >
                  Manage Account
                </li>
                <li (click)="logout()" aria-label="Log out" role="menuitem">
                  Log Out
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ng-template #content let-c="close" let-d="dismiss">
        <div class="modal-header d-block text-center container">
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="d('Cross click')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="row">
            <h1 class="col-12">Sign in</h1>
            <p class="col-12">
              No account? No worries! Simply make one after donating.
            </p>
          </div>
        </div>
        <form class="modal-body container" *ngIf="display == 'login'">
          <div>
            <text-field
              class="col-12"
              label="Email"
              type="email"
              [(ngModel)]="email"
              autocomplete="email"
              name="email"
              [required]="true"
            >
            </text-field>
            <text-field
              class="col-12"
              label="Password"
              type="password"
              autocomplete="password"
              [(ngModel)]="password"
              name="password"
              [required]="true"
            >
            </text-field>
            <div class="container">
              <p *ngIf="unableVerify" class="text-center">
                Unable to verify credentials
              </p>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  (click)="login()"
                  class="btn btn-primary btn-login"
                  aria-label="Login"
                >
                  Login
                </button>
              </div>
              <div class="d-flex justify-content-center">
                <a (click)="openResetPasswordModal()">Forgot password?</a>
              </div>
              <div class="d-flex justify-content-center">
                <div class="horizontal-divider">
                  <span>or</span>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  class="btn btn-primary google"
                  (click)="social('google')"
                  aria-label="Sign in with Google"
                >
                  Sign in with Google
                </button>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-body container" *ngIf="display == 'tfa'">
          <div>
            <div [innerHtml]="qrcode"></div>
            <text-field
              class="col-12"
              label="Verification Code"
              type="tel"
              [(ngModel)]="code"
              [required]="true"
            >
            </text-field>
            <div class="container">
              <p *ngIf="unableVerify" class="text-center">
                Unable to verify credentials
              </p>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  (click)="tfaLogin()"
                  class="btn btn-primary btn-login"
                  aria-label="Login"
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #requestResetModal let-c="close" let-d="dismiss">
        <div class="modal-header d-block text-center container">
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="d('Cross click')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="row">
            <h1 class="col-12">Reset Password</h1>
            <p class="col-12">
              Enter your email and we will send you a reset code.
            </p>
          </div>
        </div>
        <form class="modal-body container" (submit)="requestToken()">
          <div>
            <text-field
              class="col-12"
              label="Email address"
              type="email"
              [required]="true"
              [(ngModel)]="email"
              name="email"
            ></text-field>
            <div class="container">
              <p *ngIf="errorMessage" class="text-center error-block">
                {{ errorMessage }}
              </p>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  [disabled]="isLoading"
                  class="btn btn-primary"
                  aria-label="Request Password Reset"
                >
                  Request Password Reset
                </button>
              </div>
            </div>
          </div>
        </form>
      </ng-template>
      <ng-template #validateResetModal let-c="close" let-d="dismiss">
        <div class="modal-header d-block text-center container">
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="d('Cross click')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="row">
            <h1 class="col-12">Reset Code</h1>
            <p class="col-12">
              If your email address was found, we sent an email with a code. If
              you do not receive it, check your spam folder or verify you
              entered the correct email
            </p>
          </div>
        </div>
        <form class="modal-body container" (submit)="validateToken()">
          <div>
            <text-field
              class="col-12"
              label="Reset code"
              name="authCode"
              [required]="true"
              [(ngModel)]="authCode"
            ></text-field>
            <div class="container">
              <p *ngIf="errorMessage" class="text-center error-block">
                {{ errorMessage }}
              </p>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  [disabled]="isLoading"
                  class="btn btn-primary"
                  aria-label="Verify Password Reset Code"
                >
                  Validate Code
                </button>
              </div>
            </div>
          </div>
        </form>
      </ng-template>
      <ng-template #changePasswordModal let-c="close" let-d="dismiss">
        <div class="modal-header d-block text-center container">
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="d('Cross click')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="row">
            <h1 class="col-12">Change Password</h1>
            <p class="col-12">
              Enter Account Management to change your password.
            </p>
          </div>
        </div>
        <div class="modal-body container">
          <div class="container">
            <div class="d-flex justify-content-center">
              <button
                (click)="showPasswordReset()"
                type="button"
                class="btn btn-primary"
                aria-label="Manage Account"
              >
                Manage My Account
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  `
})
export class LoginComponent implements OnInit {
  modalReference: NgbModalRef;
  loggedIn: Boolean = false;
  unableVerify: Boolean = false;
  email = '';
  password = '';
  username = '';
  sessionKey = '';
  token = '';
  qrcode = '';
  secret = '';
  display = 'login';
  code = '';

  errorMessage: string;
  isLoading = false;

  @ViewChild('content', { static: true }) mainContentModal;
  @ViewChild('requestResetModal', { static: true }) requestResetModal;
  @ViewChild('validateResetModal', { static: true }) validateResetModal;
  @ViewChild('changePasswordModal', { static: true }) changePasswordModal;
  authCode: string;
  tmpSessionKey: string;

  constructor(
    private api: ApiService,
    private auth: AuthService,
    private ipService: IPService,
    private user: UserService,
    private modalService: NgbModal,
    config: NgbDropdownConfig,
    private settings: AppSettings,
    private store: Store
  ) {
    config.placement = 'bottom-right';
  }

  ngOnInit() {
    const user = this.auth.getUser();
    if (user && user.session_key) {
      this.loggedIn = true;
      this.sessionKey = user.session_key;
      this.store.dispatch(new LoginActions.LoginUser(user));
      this.loadUserProfile();
    } else {
      this.ipService.getIP().subscribe((data: any) => {
        this.setBillingInfoCountry(data.countryCode);
        this.setTributeInfoCountry(data.countryCode);
      });
    }
  }

  openLoginModal(content) {
    this.modalReference = this.modalService.open(content, { size: 'lg' });
  }

  login() {
    if (!this.email || !this.password) {
      return;
    }
    this.auth.postLogin(this.email, this.password).subscribe(
      (res: any) => {
        if (res.token) {
          this.tfa(res);
        } else {
          this.onLogin(res);
        }
      },
      () => {
        this.unableVerify = true;
      }
    );
  }

  tfaLogin() {
    if (!this.code) {
      return;
    }
    this.auth.postValidate(this.token, this.code).subscribe(
      res => this.onLogin(res),
      () => {
        this.unableVerify = true;
      }
    );
  }

  onLogin(session) {
    const data: any = session;
    this.sessionKey = data.session_key;
    this.loggedIn = true;
    this.auth.setUser(data);
    this.loadUserProfile();
    this.store.dispatch(new LoginActions.LoginUser(data));
    this.auth.startTokenCheck();
    this.modalReference.close();
  }

  tfa(tfaData) {
    this.token = tfaData.token;
    this.qrcode = tfaData.qrcode_html;
    this.secret = tfaData.secret;
    this.display = 'tfa';
  }

  social(type) {
    this.user.social(type, res => {
      if (res.timedOut) {
        this.unableVerify = true;
      } else {
        const data: any = res;
        this.sessionKey = data.session_key;
        this.loggedIn = true;
        this.auth.setUser(data);
        this.loadUserProfile();
        this.store.dispatch(new LoginActions.LoginUser(data));
        this.auth.startTokenCheck();
        this.modalReference.close();
      }
    });
  }

  logout() {
    this.auth.postLogout().subscribe(res => {
      this.loggedIn = false;
      this.sessionKey = '';
      this.store.dispatch(
        new LoginActions.LoginUser({
          refresh_token: '',
          session_expires_at: '',
          session_key: '',
          session_scope: ''
        })
      );
    });
  }

  manageAccount(overrideSessionKey: string) {
    const sessionKey = overrideSessionKey || this.sessionKey;
    let portal = this.settings.getValue('donor_portal_url');
    const slug = this.settings.getValue('organization')['slug'];
    const isBranded =
      this.settings
        .getValue('organization')
        ['features'].indexOf('branded_dss') >= 0;

    if (isBranded) {
      portal += `/${slug}`;
    }
    window.open(
      `${location.protocol}//${portal}/login#session_key=${sessionKey}`,
      '_blank'
    );
  }

  loadUserProfile() {
    this.auth.getContact().subscribe(data => {
      const contact = data['result'].contact;
      const address = contact.address;

      const billingInfo = {
        title: contact.title,
        firstName: contact.firstname,
        middleName: contact.middlename,
        lastName: contact.lastname,
        company: contact.company,
        email: contact.email,
        phone: contact.phone,
        address1: address.street,
        address2: address.street2,
        city: address.city,
        state: address.state,
        zip: address.zip,
        country: address.country
      };

      // fill in missing profile data from external sources (e.g. URL params)
      const user_data = this.settings.getValue('properties').user_data || {};

      Object.keys(billingInfo).forEach(key => {
        billingInfo[key] = billingInfo[key] || user_data[key] || null;
      });

      // If we still don't have a country code, look it up by IP
      if (!billingInfo.country) {
        this.ipService.getIP().subscribe((data: any) => {
          billingInfo.country = data.countryCode || 'US';
          this.setTributeInfoCountry(data.countryCode || 'US');
        });
      }

      this.store.dispatch(
        new BillingInfoActions.UpdateBillingInfo(billingInfo)
      );

      this.username = `${contact.firstname} ${contact.lastname[0]}`;
    });
  }

  setBillingInfoCountry(countryCode) {
    // fetch current billingInfo and replace only the country
    this.store
      .select(a => a.billingInfo)
      .pipe(take(1)) // unsubscribe after the first result
      .subscribe((billingInfo: BillingInfo) => {
        billingInfo.country = countryCode || 'US';
        this.store.dispatch(
          new BillingInfoActions.UpdateBillingInfo(billingInfo)
        );
      });
  }

  setTributeInfoCountry(countryCode) {
    // works just ilke setBillingInfoCountry, but for TributeInfo!
    this.store
      .select(a => a.tributeInfo)
      .pipe(take(1))
      .subscribe((tributeInfo: TributeInfo) => {
        tributeInfo.country = countryCode || 'US';
        this.store.dispatch(new TributeInfoActions.SetTributeInfo(tributeInfo));
      });
  }

  replaceModal(newModal) {
    if (this.modalReference) {
      this.modalReference.close();
    }

    this.modalReference = this.modalService.open(newModal);
  }

  openResetPasswordModal() {
    this.replaceModal(this.requestResetModal);
  }

  requestToken() {
    this.isLoading = true;
    this.errorMessage = null;

    this.auth
      .postResetPassword(this.email)
      .subscribe(
        res => {
          const authResponse = res as any;
          this.token = authResponse.token;
          this.replaceModal(this.validateResetModal);
        },
        err => {
          if (err.error && err.error.message) {
            this.errorMessage = err.error.message;
          } else {
            this.errorMessage = err.message;
          }
        }
      )
      .add(() => {
        this.isLoading = false;
      });
  }

  validateToken() {
    this.isLoading = true;
    this.errorMessage = null;

    this.auth
      .postValidate(this.token, this.authCode)
      .subscribe(
        res => {
          const authResponse = res as UserModel;

          // show button to user so they can click it to open a popup
          // alternative: redirect user straight to management
          this.tmpSessionKey = authResponse.session_key;
          this.replaceModal(this.changePasswordModal);
        },
        err => {
          if (err.error && err.error.message) {
            this.errorMessage = err.error.message;
          } else {
            this.errorMessage = err.message;
          }
        }
      )
      .add(() => {
        this.isLoading = false;
      });
  }

  showPasswordReset() {
    // pop open manage account window
    this.manageAccount(this.tmpSessionKey);

    // return user to login behind the scenes
    this.replaceModal(this.mainContentModal);
  }
}
